// last-comments
(function() {
	var lastComments = $('#last-comments');
	
	lastComments.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		appendArrows: false
	});

	lastComments.on('swipe', function(event, slick, direction){
		$('#slider-navigation-counter').find('.current').text(lastComments.slick('slickCurrentSlide') + 1);
	});

})();


// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/last-comments/last-comments.js